export default __webpack_public_path__ + "static/thankyou-050231bc4383af94a752bdcf8179eba5.jpg";